import { Notification } from '@mantine/core';

export const NotificationTheme = Notification.extend({
	styles: {
		icon: {
			color: 'var(--mantine-primary-color-contrast)',
		},
	},
});
